module.exports = __webpack_public_path__ + "img/barcode.ba2e9e92.gif";